import validator from "validator";
import message from "../../../messages/auth";

const validateEmail = (email) => {
  if (validator.isEmpty(email)) {
    return message.EMAIL_DOSE_NOT_EXIST;
  }

  if (!email.trim().length) {
    return message.EMAIL_DOSE_NOT_EXIST;
  }

  if (!validator.isEmail(email)) {
    return message.EMAIL_INVALID;
  }

  return true;
};

const validationForgetPassword = (info) => {
  const resValidateForgetPassword = validateEmail(info.email);
  if (resValidateForgetPassword != true) {
    return resValidateForgetPassword;
  }

  return true;
};

export default validationForgetPassword;
